import { SessionResponseDto } from '../dtos/session/session.response.dto';
import { SessionRequestDto } from '../dtos/session/session.request.dto';
import { Session } from '@domain/session/session';

export class SessionMapper {
  static fromDto(dto: SessionResponseDto): Session {
    return new Session(
      dto.id,
      dto.startDateTime,
      dto.endDateTime,
      dto.note,
      dto.exported,
      dto.active,
      dto.dispositifId,
      dto.dispositifName,
      dto.activityId ?? null,
      dto.activityName ?? null,
      dto.userId,
      dto.userUsername,
      dto.lieuId ?? null,
      dto.lieuNom ?? null,
      (dto.participants ?? []).map(p => ({
        id: p.id!,
        firstName: p.firstName,
        lastName: p.lastName,
        birthDate: p.birthDate,
        active: p.active,
      })),
    );
  }

  static toRequestDto(entity: Session): SessionRequestDto {
    return {
      startDateTime: entity.startDateTime,
      endDateTime: entity.endDateTime,
      note: entity.note,
      dispositifId: entity.dispositifId,
      activityId: entity.activityId,
      userId: entity.userId,
      lieuId: entity.lieuId,
      participantIds: entity.participants.map(p => p.id),
    };
  }
}
